// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__LQDSv","rank":"style_rank__mh4ti"};